require("!!/home/jormat/jormat-front/node_modules/script-loader/addScript.js")(require("!!/home/jormat/jormat-front/node_modules/raw-loader/index.js!/home/jormat/jormat-front/bower_components/moment/locale/es.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/moment/locale/es.js
// module id = 532
// module chunks = 0